const STORAGE_DATABASE_NAME = '@sosplantao';

export const STORAGE_TABLE_GROUP = `${STORAGE_DATABASE_NAME}_grupo`;
export const STORAGE_TABLE_GROUP_VERSION = 'v1';

// export const STORAGE_TABLE_USERS = `${STORAGE_DATABASE_NAME}_users`;
// export const STORAGE_TABLE_USERS_VERSION = 'v1';
